export const ACCOUNT = {
  GENERATE_OTP: '/account/otp/generate/',
  LOGOUT: '/account/auth/logout/',
  RESEND_OTP: '/account/otp/resend/',
  VERIFY_OTP: '/account/otp/verify/',
  COUNTRIES: '/account/countries/',
};

export const USER = {
  PROFILE: '/account/api/user/profile/',
  PERSONAL_DETAILS: '/portal/api/user/user-personal-details/',
  CONTACT_DETAILS: '/portal/api/user/contact-details/',
  PROFESSIONAL_DETAILS: '/portal/api/user/professional-details/',
  BIO_DETAILS: '/portal/api/user/bio-details/',
  WITHDRAWN_APPLICATION: '/portal/api/user/application/withdrawn/',
  MEMBERSHIP_PLANS: '/portal/api/common/membership-plan-list/',
  CHOOSE_MEMBERSHIP: '/portal/api/user/choose-membership/',
  INITIATE_PAYMENT: '/portal/api/user/payment/initiate/',
  VERIFY_PAYMENT: '/portal/api/user/payment/verify/',
  GENERATE_CERTIFICATE_PRESIGNED_URL:
    '/portal/api/common/generate-presigned-s3-url/',
  GENERATE_PROFILE_PHOTO_PRESIGNED_URL:
    '/portal/api/common/generate-profile-pic-presigned-s3-url/',
  DELETE_PROFILE_PHOTO: '/portal/api/common/delete-profile-pic-from-s3/',
  DELETE_CERTIFICATE: '/portal/api/common/delete-file-from-s3/',
  GET_RADICAL_MEMBERS: '/portal/api/common/member/',
  SELECT_PROPOSER_SECONDER: '/portal/api/user/select-proposer-seconder/',
  UPDATE_PAYMENT_STATUS: '/portal/api/user/update-payment-status/',
};

export const RADICAL_MEMBER = {
  RATIFICATION_REQUEST_LIST: '/portal/api/member/ratification-request/',
  UPDATE_RATIFICATION_STATUS: '/portal/api/member/update-ratification-status/',
  RATIFICATION_REQUEST_DETAIL: '/portal/api/member/ratification-request/',
};

export const ADMIN = {
  REMINDER: {
    INACTIVE_APPLICATIONS: '/portal/api/admin/application/inactive/',
    SEND_REMINDER: '/portal/api/admin/application/send-reminder/',
  },
  APPLICATION: {
    REJECT: '/portal/api/admin/application/reject/',
    UPDATE: '/portal/api/admin/application/',
    CONFIRM_MEMBERSHIP: '/portal/api/admin/confirm-membership/',
    APPLICATION_LIST: '/portal/api/admin/application/',
    APPROVE: 'portal/api/admin/application/update-ratification-status/',
  },
  PAYMENT: {
    RECORD_OFFLINE_PAYMENT:
      '/portal/api/admin/application/record-offline-payment/',
    OFFLINE_REFUND: '/portal/api/admin/payment/offline-refund/',
  },
  PORTAL_OVERVIEW: '/portal/api/admin/overview/',
  INVOICE: {
    INVOICE_LIST: '/portal/api/admin/invoice/',
    RESEND_INVOICE: '/portal/api/admin/invoice/resend/',
    EXPORT_INVOICE: '/portal/api/admin/invoice/export/',
    INVOICE_DATA: '/portal/api/admin/invoice-data/',
  },
  PAYMENTS_OVERVIEW: '/portal/api/admin/payments/overview/',
  MEMBERSHIP: {
    CREATE_PLAN: '/portal/api/admin/membership-plan/',
    UPDATE_PLAN: '/portal/api/admin/membership-plan/',
  },
  MANAGE_ADMINS: {
    ADMIN_LIST: '/portal/api/admin/',
    ADD: '/portal/api/admin/add/',
    REMOVE: '/portal/api/admin/remove/',
  },
  GROUP: {
    GENERATE_PRESIGNED_COVER_PHOTO_URL:
      '/portal/api/admin/group/generate-cover-pic-presigned-url/',
    FETCH_COVER_PHOTO: '/portal/api/admin/group/cover-pic/',
    DELETE_COVER_PHOTO: '/portal/api/admin/group/delete-cover-pic/',
    CREATE_GROUP: '/portal/api/admin/group/',
    UPDATE_GROUP_DETAILS: '/portal/api/admin/group/',
  },
};

export const COMMON = {
  APPLICANT_PROFILE: '/portal/api/common/application/retrieve/',
  MEMBER: {
    MEMBER_LIST: '/portal/api/common/member/',
  },
  GROUP: {
    GROUP_LIST: '/portal/api/common/group/',
  },
};
